import './Tooltip.scss';
import React from 'react';
import {connect} from "react-redux";
import T from "../t/T";
import {Tooltip as Tooltp} from 'antd';

const Tooltip = (props) => {
    let { icon='fa fa-light fa-circle-info',
          text="",
          className=''
    } = props
    let child = props.children ? props.children : <i className={icon} />

    return <Tooltp title={ <T token={text} /> }
                   trigger="hover"
                   overlayClassName={className}
    >
        {child}
    </Tooltp>
}


const mapStateToProps = state => {
    const language = state.LangReducer.language;
    return {language};
};

export default connect(mapStateToProps)(Tooltip);